// LineChart.js
import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const ForecastBarChart = ({ data }) => {
  const processData = data.map((entry) => ({
    ...entry,
    weightedValue: entry.value, // Assuming value is already weighted in Dashboard.js
    complianceScore: entry.complianceScore || 0,
  }));

  return (
    <LineChart width={500} height={300} data={processData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip formatter={(value, name) => `${name}: ${value.toFixed(2)}`} />
      <Legend />
      <Line type="monotone" dataKey="weightedValue" stroke="#8884d8" name="Weighted Revenue" />
      <Line type="monotone" dataKey="complianceScore" stroke="#82ca9d" name="Compliance Score" />
    </LineChart>
  );
};

export default ForecastBarChart;
